import { emitGame, GameEvents } from './events';

export function requestPanel(index: 0 | 1) {
  emitGame(GameEvents.PANEL_REQUEST, index);
}
